import { render, staticRenderFns } from "./FileUploaderTransparent.vue?vue&type=template&id=5c21251e&scoped=true"
import script from "./FileUploaderTransparent.vue?vue&type=script&lang=js"
export * from "./FileUploaderTransparent.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderTransparent.vue?vue&type=style&index=0&id=5c21251e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21251e",
  null
  
)

export default component.exports